import { Component, inject, ChangeDetectionStrategy, ChangeDetectorRef, } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { trigger, transition, style, animate, query, stagger, group } from '@angular/animations';
import { UtilityService, UtilityApp } from '../../../core/services/utility.service';

@Component({
  selector: 'app-utilities-list',
  imports: [MatCardModule, MatListModule, MatIconModule, MatButtonModule, RouterLink],
  templateUrl: './utilities-list.component.html',
  styleUrl: './utilities-list.component.css',
  animations: [
    trigger('pageChangeAnimation', [
      transition('* => *', [
        query(':enter', [
          style({ 
            opacity: 0, 
            transform: 'translateY(5px)' 
          }),
          stagger(100, [
            animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)', 
              style({ 
                opacity: 1, 
                transform: 'translateY(0)' 
              })
            )
          ])
        ], { optional: true })
      ])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UtilitiesListComponent {
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  utilityService = inject(UtilityService);
  
  currentPage = 0;
  itemsPerPage = 4;

  get displayedUtilities() {
    const start = this.currentPage * this.itemsPerPage;
    return this.utilityService.utilities.slice(start, start + this.itemsPerPage);
  }

  get canNavigateBack() {
    return this.currentPage > 0;
  }

  get canNavigateForward() {
    return (this.currentPage + 1) * this.itemsPerPage < this.utilityService.utilities.length;
  }

  navigatePage(direction: 'prev' | 'next') {
    if (direction === 'prev' && this.canNavigateBack) {
      this.currentPage--;
    } else if (direction === 'next' && this.canNavigateForward) {
      this.currentPage++;
    }
    // Force change detection after updating displayedUtilities
    this.cdr.markForCheck();
  }
}
